@if (featuredLinks() || seoTabContentList()) {
	<div class="seo-content-container hmf-mt-s hmf-px-s">
		<h2>{{seoHeader()}}</h2>
		@for (seoTabContent of seoTabContentList(); track trackByHeader($index, seoTabContent.header)) {
			<homefield-accordion
				[header]="seoTabContent.header | titlecase"
				[isInline]="true"
				[isExpanded]="true"
				[enablePanelContent]="true">
				<div ngProjectAs="customAccordionContent">
					<div class="hmf-pl-m hmf-mr-s hmf-py-s tab-content hmf-body-m" [innerHTML]="seoTabContent.content"></div>
				</div>
			</homefield-accordion>
		}
		@if (featuredLinks()) {
			<homefield-accordion
				[header]="'featured categories' | titlecase"
				[isInline]="true"
				[isExpanded]="true"
				[enablePanelContent]="true">
				<div class="featured-category-container tab-content hmf-body-m" ngProjectAs="customAccordionContent">
					<ul>
						@for (featureLink of featuredLinks(); track trackByKey($index, featureLink.key)) {
							<li class="hmf-mr-xxs">
								<a hmf-text-link variant="primary" [linkURL]="featureLink.value">
									{{featureLink.key}}
								</a>
							</li>
						}
					</ul>
				</div>
			</homefield-accordion>
		}
	</div>
}
